import * as jsBridge from '@vipsdk/js-bridge'
export default {
  API: {
    // 页面加载完成
    client_domLoaded () {
      return jsBridge.client_dom_loaded()
    },
    // 登录
    userLogin (params) {
      return jsBridge.client_open_login_window(params)
    },
    // 刷新用户
    paySuccess (params) {
      return jsBridge.client_refresh_userinfo(params)
    },
    // 退出
    exit () {
      return jsBridge.client_logout()
    },
    // 数据恢复
    openRecovery (params) {
      return this.callClient(params)
    },
    // 打开百宝箱
    callClient (params) {
      return jsBridge.client_open_vip_box(params)
    },
    // 替换函数
    replaceObj (target, obj) {
      Object.keys(target).forEach(item => {
        target[item] = (obj[item] || target[item]) + ''
      })
      return target
    },
    // 反馈入口
    client_feedback () {
      return jsBridge.client_feedback()
    },

    // 检查客户端方法
    client_checkMethod (methodName) {
      return jsBridge.client_checkMethod(methodName)
    },

    client_getVipVersion () {
      return jsBridge.client_getVipVersion()
    },

    client_getTryNo () {
      return jsBridge.client_getTryNo()
    },

    client_openKisProcess (params) {
      return jsBridge.client_openKisProcess(params)
    },

    client_openOptionWindow (params) {
      return jsBridge.client_openOptionWindow(params)
    },

    client_check_switch (params) {
      return jsBridge.client_check_switch(params)
    },

    client_check_abtest (params) {
      return jsBridge.client_check_abtest(params)
    },

    client_open_vip_box (params) {
      return jsBridge.client_open_vip_box(params)
    },
    // sdk统一检查毒霸是否安装
    client_is_duba_installed () {
      return jsBridge.callRequest({
        fnName: 'isDubaInstalled'
      })
    },
    // sdk去安装毒霸
    client_install_duba (params) {
      return jsBridge.callRequest({
        fnName: 'installDuba',
        params
      })
    },
    // sdk统一打开
    duba_app_common_open (params) {
      return jsBridge.callRequest({
        fnName: 'openDubaRight',
        params
      })
    },
    // sdk统一打开
    client_getTid (params) {
      return jsBridge.callRequest({
        fnName: 'getTid',
        params
      })
    },
    // 获取客户端子产品id和产品功能id
    client_getScenesInfo () {
      return jsBridge.callRequest({ fnName: 'getScenesInfo' })
    },

    /**  登录--删除用户信息 */
    client_deleteUser (params) {
      return jsBridge.callRequest({
        fnName: 'deleteUser',
        params
      })
    },
    /** 登录--关闭窗口 */
    client_closeWindow () {
      return jsBridge.callRequest({ fnName: 'closeWindow' })
    },
    // 客户端关闭
    client_winclose (params) {
      return jsBridge.client_winclose(params)
    },
    /**  获取ocpc url */
    getOcpcUrl () {
      return jsBridge.callRequest({ fnName: 'getOcpcUrl' })
    },

    /** 获取客户端安装时间 */
    client_install_time () {
      return jsBridge.callRequest({ fnName: 'GetCurrentProductInstallTime' })
    },

    /** 获取设备的信息 系统名和版本 (系统版本号) */
    client_get_device_info () {
      return jsBridge.client_get_device_info()
    },

    /** 客户端主版本号 */
    client_major_version () {
      return jsBridge.callRequest({ fnName: 'getReaderVersion' })
    },
    /**
     * 调起客户端升级弹窗
     */
    client_openKisProcessNew() {
      return jsBridge.callRequest({
        fnName: 'openKisProcess',
        params: {
          name: "fastpdf.exe",
          arg: {
            task: "manual_upgrade[0,1]"
          }
        }
      })
    },
    /**
     * 通过客户端方法打开浏览器
     */
    client_openBrowser(url) {
      return jsBridge.callRequest({
        fnName: 'openBrowser',
        params: {
          url
        }
      })
    }
  },
  REPORT: {
    client_report_by_kfmt (table, info) {
      return jsBridge.client_report_by_kfmt(table, info)
    },
  }
}
